import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import RemoveIcon from '@mui/icons-material/Remove';

const TrendIndicator = ({ value, direction, showValue = true }) => {
  const isPositive = direction === 'up';
  const isNeutral = direction === 'stable';
  
  const color = isNeutral ? '#999999' : isPositive ? '#4CAF50' : '#F44336';
  const displayValue = typeof value === 'number' ? Math.abs(value).toFixed(1) : value;
  const sign = isNeutral ? '' : isPositive ? '+' : '-';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.25rem',
        color: color,
        fontSize: '0.9rem',
        fontWeight: 600,
      }}
    >
      {isNeutral ? (
        <RemoveIcon sx={{ fontSize: '1rem' }} />
      ) : isPositive ? (
        <TrendingUpIcon sx={{ fontSize: '1rem' }} />
      ) : (
        <TrendingDownIcon sx={{ fontSize: '1rem' }} />
      )}
      {showValue && (
        <span>
          {sign}{displayValue}
        </span>
      )}
    </Box>
  );
};

TrendIndicator.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  direction: PropTypes.oneOf(['up', 'down', 'stable']).isRequired,
  showValue: PropTypes.bool,
};

export default TrendIndicator;
